import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useCycleShopifyTokenMutation$data,
  useCycleShopifyTokenMutation as useCycleShopifyTokenMutationType,
} from "./__generated__/useCycleShopifyTokenMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useCycleShopifyTokenMutation($brandId: ID!) {
    cycleShopifyToken(brandId: $brandId) {
      state
      accessTokenLast4
      accessTokenExpiresAt
      refreshTokenExpiresAt
      refreshedAt
      error
      adminChangeUrl
    }
  }
`;

const useCycleShopifyTokenMutation = (): [
  (
    brandId: string,
    onCompleted?: (data: useCycleShopifyTokenMutation$data) => void
  ) => void,
  boolean
] => {
  const [commitMutation, isMutationInFlight] =
    useMutation<useCycleShopifyTokenMutationType>(mutation);
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      brandId: string,
      onCompleted?: (data: useCycleShopifyTokenMutation$data) => void
    ) => {
      commitMutation({
        variables: { brandId },
        onCompleted: (data, errors) => {
          if (errors) {
            snackbarContext?.openSnackbar(
              "Could not cycle the Shopify token",
              "error"
            );
          } else {
            onCompleted && onCompleted(data);
            snackbarContext?.openSnackbar("Shopify token cycled", "success");
          }
        },
        onError: () => {
          snackbarContext?.openSnackbar(
            "Could not cycle the Shopify token",
            "error"
          );
        },
      });
    },
    [commitMutation, snackbarContext]
  );

  return [onMutate, isMutationInFlight];
};

export default useCycleShopifyTokenMutation;
